module.exports = __webpack_public_path__ + "static/media/rails.ff39bd09.png";